import { render, staticRenderFns } from "./SupplierShippingCountriesComponent.vue?vue&type=template&id=f5b79408&"
import script from "./SupplierShippingCountriesComponent.vue?vue&type=script&lang=js&"
export * from "./SupplierShippingCountriesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports